// extracted by mini-css-extract-plugin
export default {"input__container":"SimpleInput_input__container__n193n","vacantest__input":"SimpleInput_vacantest__input__B9JIY","dropdown__content":"SimpleInput_dropdown__content__aGDz8"};